import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  TextField,
  Button,
  Box,
  Typography,
  Container,
  Snackbar,
  Alert,
} from '@mui/material'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import CustomTextField from "./CustomTextField";
import apiService from '../services/ApiService'
import { useAuth } from '../context/AuthContext'
const FeedbackForm = ({ articleId, onClose, showSnackbar }) => {
  const { user, isAuthenticated } = useAuth()
  const [feedbackText, setFeedbackText] = useState('')
  const [userEmail, setUserEmail] = useState('')
  // const [snackbarOpen, setSnackbarOpen] = useState(false)
  // const handleSnackbarClose = (event, reason) => {
  //   if (reason === 'clickaway') return
  //   setSnackbarOpen(false)
  // }
   useEffect(() => {
     if (isAuthenticated && user) {
       setUserEmail(user.email || '')
     }
   }, [isAuthenticated, user])
  const handleSubmit = async (event) => {
    event.preventDefault()
    const feedback = {
      articleId,
      feedbackText,
      userEmail: userEmail || (user ? user.email : ''),
      // userId: user ? user.id : null, // we need to add userId to feedback DTO to accept it in backend
    }

    try {
      await apiService.post('/api/v1/feedbacks/', feedback)

      setFeedbackText('')
      // Only clear email if user is not authenticated
      if (!isAuthenticated) {
        setUserEmail('')
      }
      onClose()
      showSnackbar('Feedback submitted successfully 😄', 'success')
      // setSnackbarOpen(true)  <-- we can't directly render Snackbar by mentioning it in FeedbackForm component, why??
      //       <Modal /> present in <ArticleCard /> , and inside Modal we have <Article />, and in Article we have <FeedbackForm /> which is try to render <Snackbar />
      // The modal's rendering behavior could interfere with how the Snackbar is displayed. Snackbars usually render on the top of the DOM tree, and being inside a modal might restrict its visibility due to the modal's context and z-index behavior.
    } catch (error) {
      console.error('Error submitting feedback:', error)
      showSnackbar('Failed to submit feedback 😞', 'error') // Show error Snackbar
    }
  }

  return (
    <>
      <Container maxWidth='sm'>
        <Box
          component='form'
          onSubmit={handleSubmit}
          sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 2 }}
        >
          <Typography variant='h5' component='h2' gutterBottom>
            Submit Feedback
          </Typography>
          <CustomTextField
            id='feedbackText'
            label='Report any broken links, or any misleading data in this article'
            variant='outlined'
            multiline
            rows={4}
            value={feedbackText}
            onChange={(e) => setFeedbackText(e.target.value)}
            required
            // fullWidth
            // margin='normal'
          />
          {/* <TextField
            id='feedbackText2'
            label='Report any broken links, or any misleading data in this article'
            variant='outlined'
            multiline
            rows={4}
            value={feedbackText}
            onChange={(e) => setFeedbackText(e.target.value)}
            required
          /> */}
          <CustomTextField
            id='userEmail'
            label='Email'
            type='email'
            variant='outlined'
            value={userEmail}
            multiline
            rows={1}
            onChange={(e) => setUserEmail(e.target.value)}
            required
            disabled={isAuthenticated && user?.email} // Disable if user is logged in and has email
            helperText={
              isAuthenticated && user?.email ? 'Using your account email' : ''
            }
          />
          {/* <TextField
            id='userEmail'
            label='Email'
            type='email'
            variant='outlined'
            value={userEmail}
            onChange={(e) => setUserEmail(e.target.value)}
            required
          /> */}
          {/* <Button variant='contained' color='primary' type='submit'>
            Submit
          </Button>
          <Button variant='outlined' color='secondary' onClick={onClose}>
            Close
          </Button> */}
          <Box
            display='flex'
            justifyContent='flex-end'
            // justifyContent='space-evenly'
            // mt={2}
          >
            <Button
              variant='contained'
              type='submit'
              startIcon={<CheckCircleRoundedIcon />}
              sx={{
                color: '#fff',
                bgcolor: '#232536',
                // mr: 2,
                fontWeight: 500,
                ':hover': {
                  color: '#232536',
                  bgcolor: '#ffcf51',
                  // flexGrow: 1,
                },
              }}
            >
              Submit
            </Button>
            {/* <Button
              variant='outlined'
              onClick={onClose}
              sx={{
                color: '#232536',
                bgcolor: '#fff',
                borderColor: '#232536',
                fontWeight: 500,
                ':hover': {
                  color: '#232536',
                  bgcolor: '#ffcf51',
                  borderColor: '#232536',
                  // flexGrow: 1,
                },
              }}
            >
              Close
            </Button> */}
          </Box>
        </Box>
      </Container>
      {/* <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity='success'
          sx={{ width: '100%' }}
        >
          Feedback submitted successfully 😄
        </Alert>
      </Snackbar> */}
    </>
  )
}

export default FeedbackForm;
